import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';

const ReportYearIndex = () => {
    const navigate = useNavigate();

    // Configuração de filtros
    const filterConfig = useMemo(() => [
        {
            type: "text",
            name: "year",
            label: "Year",
            placeholder: "Search by year..."
        },
        {
            type: "text",
            name: "cultureDescription",
            label: "Culture",
            placeholder: "Search by culture..."
        }
    ], []);

    // Colunas da tabela
    const columns = useMemo(() => [
        { 
            title: 'Report Year', 
            dataIndex: 'year', 
            key: 'year', 
            sortable: true,
            width: 120
        },
        { 
            title: 'Start Date', 
            dataIndex: 'beginDate', 
            key: 'beginDate', 
            sortable: true,
            type: 'date',
            render: (value) => moment(value).format("DD-MMM-YYYY")
        },
        { 
            title: 'End Date', 
            dataIndex: 'endDate', 
            key: 'endDate', 
            sortable: true,
            type: 'date',
            render: (value) => moment(value).format("DD-MMM-YYYY")
        },
        { 
            title: 'Crop', 
            dataIndex: 'culture.description', 
            key: 'culture.description', 
            sortable: true 
        },
        { 
            title: 'Active', 
            dataIndex: 'isActive', 
            key: 'isActive', 
            width: 100,
            render: (value, record, index, handleToggleActive) => (
                <span 
                    className={`badge ${value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleActive && handleToggleActive(record)}
                    title={`Click to ${value ? 'deactivate' : 'activate'}`}
                >
                    {value ? 'Active' : 'Inactive'}
                </span>
            )
        },
        { 
            title: 'Deleted', 
            dataIndex: 'isDeleted', 
            key: 'isDeleted', 
            width: 100,
            render: (value, record, index, handleToggleActive, handleToggleDeleted) => (
                <span 
                    className={`badge ${!value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleDeleted && handleToggleDeleted(record)}
                    title={`Click to ${!value ? 'delete' : 'restore'}`}
                >
                    {!value ? 'Not Deleted' : 'Deleted'}
                </span>
            )
        }
    ], []);

    // Actions
    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/reportYear/edit/${record.reportYearID}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="Report Year"
            apiEndpoint="/ReportYear/getAllPaginated"
            toggleActiveEndpoint="/ReportYear/toggleActive"
            toggleDeletedEndpoint="/ReportYear/toggleDeleted"
            newRoute="/reportYear/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="reportYearID"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default ReportYearIndex;
